var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHopital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.04,5.23h-6.34c-1.38,0-2.5,1.12-2.5,2.5v17.8h-18.47V7.73c0-1.38-1.12-2.5-2.5-2.5h-6.26c-1.38,0-2.5,1.12-2.5,2.5v48.53c0,1.38,1.12,2.5,2.5,2.5h6.26c1.38,0,2.5-1.12,2.5-2.5v-20.25h18.47v20.25c0,1.38,1.12,2.5,2.5,2.5h6.34c1.38,0,2.5-1.12,2.5-2.5V7.73c0-1.38-1.12-2.5-2.5-2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHopital);
export default __webpack_public_path__ + "static/media/hopital.fd341f4e1986b0aebd0bdcb7ef2436e4.svg";
export { ForwardRef as ReactComponent };